import { myVisitCounselApi } from '@/entities/planner/model/my-planner.api';
import type { VisitCounselView } from '@/entities/visit-counsel/model/visit-counsel.types';

/**
 * intake-session 이 REQUESTED 면 startIntakeSession 호출.
 *
 * 백엔드는 "REQUESTED 상태에서만 start 가능" 정책이라 다른 상태(STARTED/COMPLETED/null)
 * 에서 호출하면 409 가 떨어진다. 따라서 status 가 정확히 'REQUESTED' 일 때만 시도하고,
 * 그 외에는 no-op 한다.
 *
 * record API 들은 STARTED 가 필요하므로 progress-flow 의 모든 step 어댑터는 마운트
 * 시점에 본 함수를 호출해 사용자 입력 시작 전에 세션을 보장한다. 이미 STARTED 면
 * 그대로 진행, REQUESTED 면 STARTED 로 전환.
 *
 * race 로 중복 호출돼도 record API 가 다시 검증하므로 호출 실패는 warn 만 남기고 통과.
 */
export async function ensureIntakeSessionStarted(
  visitCounselId: string,
  counsel: VisitCounselView | null | undefined
): Promise<void> {
  const status = counsel?.sessions?.intake?.status;
  if (status !== 'REQUESTED') return;
  try {
    await myVisitCounselApi.startIntakeSession(visitCounselId);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[progress-flow] startIntakeSession failed (continuing):', err);
  }
}
